import * as React from 'react'
import { memo } from 'react'
const SvgCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 11.634"
  >
    <path d="M5.549 11.634 0 6.085l1.183-1.183 4.366 4.366L14.817 0 16 1.183Z" />
  </svg>
)
const Memo = memo(SvgCheck)
export default Memo
